import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IProductColor,
  IProductColorState,
  IProductColorFormValues,
  IProductColorErrors,
} from "../../../types/product/productColorInterfaces";

export const initialForm: IProductColorFormValues = {
  id: 0,
  code: "",
  name: "",
};

export const initialState: IProductColorState = {
  productColors: [],
  productColorsDropdown: [],
  form: initialForm,
  formErrors: {},
  isSubmit: false,
  isCreateModalOpen: false,
  isEditModalOpen: false,
};

export const productColorSlice = createSlice({
  name: "productColors",
  initialState,
  reducers: {
    // ========================================
    // FETCH
    // ========================================
    loadingProductColors: (state, action: PayloadAction<IProductColor[]>) => {
      state.productColors = action.payload;
    },

    loadingProductColorsDropdown: (
      state,
      action: PayloadAction<{ id: number; name: string }[]>
    ) => {
      state.productColorsDropdown = action.payload;
    },

    // ========================================
    // FORM
    // ========================================
    updateFormField: (
      state,
      action: PayloadAction<{ field: string; value: any }>
    ) => {
      const { field, value } = action.payload;
      (state.form as any)[field] = value;
    },

    setForm: (state, action: PayloadAction<IProductColorFormValues>) => {
      state.form = action.payload;
    },

    resetForm: (state) => {
      state.form = initialForm;
      state.formErrors = {};
      state.isSubmit = false;
    },

    // ========================================
    // FORM ERRORS
    // ========================================
    setFormErrors: (state, action: PayloadAction<IProductColorErrors>) => {
      state.formErrors = action.payload;
    },

    clearFormErrors: (state) => {
      state.formErrors = {};
    },

    // ========================================
    // SUBMIT FLAG
    // ========================================
    setSubmit: (state, action: PayloadAction<boolean>) => {
      state.isSubmit = action.payload;
    },

    // ========================================
    // MODALS
    // ========================================
    openCreateModal: (state) => {
      state.isCreateModalOpen = true;
    },

    closeCreateModal: (state) => {
      state.isCreateModalOpen = false;
    },

    openEditModal: (state) => {
      state.isEditModalOpen = true;
    },

    closeEditModal: (state) => {
      state.isEditModalOpen = false;
    },

    // ========================================
    // CRUD CORE
    // ========================================
    addProductColor: (state, action: PayloadAction<IProductColor>) => {
      state.productColors.push(action.payload);
    },

    updateProductColor: (state, action: PayloadAction<IProductColor>) => {
      state.productColors = state.productColors.map((color) =>
        color.id === action.payload.id ? { ...color, ...action.payload } : color
      );
    },

    toggleStateProductColor: (
      state,
      action: PayloadAction<{ id: number; status: boolean }>
    ) => {
      const { id, status } = action.payload;
      state.productColors = state.productColors.map((color) =>
        color.id === id ? { ...color, status } : color
      );
    },
  },
});

export const {
  loadingProductColors,
  loadingProductColorsDropdown,
  updateFormField,
  setForm,
  resetForm,
  setFormErrors,
  clearFormErrors,
  setSubmit,
  openCreateModal,
  closeCreateModal,
  openEditModal,
  closeEditModal,
  addProductColor,
  updateProductColor,
  toggleStateProductColor,
} = productColorSlice.actions;

export default productColorSlice.reducer;
